import { initializeApp, getApp } from 'firebase/app';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  type Firestore,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

// Configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCIi-61z2oHVmD4okdLkLzoL1E83ggk4a0",
  authDomain: "redline-e1775.firebaseapp.com",
  projectId: "redline-e1775",
  storageBucket: "redline-e1775.firebasestorage.app",
  messagingSenderId: "213088075878",
  appId: "1:213088075878:web:5cddf8c7691a6b689beda7",
  measurementId: "G-6XE5Z7JBW3"
};

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  // console.warn supprimé
  app = getApp();
}

// Initialize Auth without setting persistence by default
// La persistance sera gérée par le service d'authentification
const auth = getAuth(app);

// Initialize Firestore avec le cache local persistant (IndexedDB).
//
// Pourquoi c'est important pour la facturation Firestore :
// un listener `onSnapshot` n'est facturé qu'à l'attache initiale (1 lecture par document
// du résultat) puis 1 lecture par document réellement ajouté / modifié / supprimé.
// Quand le listener se ré-attache (navigation, rechargement de page, retour d'onglet),
// le SDK réutilise le "resume token" stocké dans le cache local et le serveur ne renvoie
// que le delta — donc 0 lecture s'il ne s'est rien passé. Sans cache persistant, ce token
// est perdu à chaque rechargement de page et la requête est refacturée intégralement.
// (Le delta n'est possible que si la reconnexion a lieu dans les 30 min ; au-delà Firestore
// refacture la requête complète, comportement documenté et inévitable.)
//
// `persistentMultipleTabManager` permet à plusieurs onglets de partager le même cache
// (sans lui, un seul onglet obtiendrait la persistance).
let db: Firestore;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  });
} catch {
  // Firestore déjà démarré (HMR, double import) ou IndexedDB indisponible
  // (navigation privée, WebView restreinte) : on retombe sur l'instance par défaut.
  db = getFirestore(app);
}

// Initialize Storage
const storage = getStorage(app);

// Fonctions sécurisées pour obtenir les instances
export async function getFirebaseAuth() {
  return auth;
}

export async function getFirebaseDb() {
  return db;
}

export async function getFirebaseStorage() {
  return storage;
}

// Export des instances (uniquement après initialisation)
export { db, auth, storage, app };
